import React from 'react';
import {
  Slider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  customWidth: {
    width: '265px',
    zIndex: '2'
  },
  fixedBackdrop: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  },
  zIndex2: {
    zIndex: '2'
  }
});

const BorderRadiusPickerDialog = ({value, setShowBorderRadiusPicker, onChange}) => {
  const classes = useStyles();
  const borderRadius = value.includes('px')
    ? value.replace('px', '')
    : value;

  return (
    <div className={`relative ${classes.customWidth} ${classes.zIndex2}`}>
      <div
        className={classes.fixedBackdrop}
        onClick={() => setShowBorderRadiusPicker(false)}
      />
      <div className={`bg-white elevation-z5 p-5 absolute w-full ${classes.zIndex2}`}>
        <div className="pt-8">
          <Slider
            value={borderRadius}
            step={1}
            max={100}
            valueLabelDisplay="on"
            onChange={(_, value) => onChange(`${value}px`)}
          />
        </div>
      </div>
    </div>);
};

export default BorderRadiusPickerDialog;
